import { RenderContentBlock } from '@tunasong/editor'
import { Band, Controls, ViewList } from '@tunasong/icons'
import { FolderControls } from '@tunasong/plugin-folder/controls.js'
import type { TunaPlugin } from '@tunasong/plugin-lib'
import { condRenderComponent } from '@tunasong/plugin-lib'
import type { BandSpace } from '@tunasong/schemas'
import { isBandSpace, isFolder } from '@tunasong/schemas'
import { generateRiderCommand } from './commands/generate-rider.js'
import ListContent from './content/list.js'
import { ConvertToBandspaceMenuItem } from './convert.js'
import { setup } from './setup.js'
import template from './templates/default.js'
import DefaultView from './views/default.js'
import StyleView from './views/style.js'

const plugin = (): TunaPlugin<BandSpace> => ({
  key: 'bandspace',
  category: 'music',
  color: 'deepPurple',
  maturity: 'stable',
  description: 'Band space',
  icon: Band,
  openIcon: Band,
  node: {
    type: 'bandspace',
    isElement: true,
    component: RenderContentBlock,
  },
  templates: [
    {
      template,
      name: 'Band space',
      onCreate: setup,
    },
  ],
  allowChildrenTypes: true,
  getEntityCommands: context => {
    if (!isBandSpace(context.entity)) {
      return []
    }
    return generateRiderCommand(context)
  },
  components: {
    Content: {
      list: ListContent,
    },
    Actions: condRenderComponent(isFolder, [ConvertToBandspaceMenuItem]),
  },
  layouts: [
    {
      name: 'Home',
      Component: DefaultView,
      Icon: ViewList,
      slots: {
        EntityControls: FolderControls,
      },
      container: {},
    },
    {
      name: 'Style',
      Component: StyleView,
      Icon: Controls,
      container: {},
    },
  ],
})

export default plugin
